import { PersonalDataModel } from '../../../../../shared/models/view/PersonalData';
import { AppUtils } from '../../../../../shared/utils/index';

export class AppFormModel {
	private personalData: PersonalDataModel;

	public get PersonalData(): PersonalDataModel {
		return this.personalData;
	}
	public set PersonalData(value: PersonalDataModel) {
		this.personalData = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): AppFormModel {
		return AppUtils.Helper.createFromMap(dataObject, AppFormModel, (key: string, value: any) => {
			switch (key) { //NOSONAR
				case 'personalData':
					return PersonalDataModel.createFromObject(value);
				default:
					return value;
			}
		});
	}
}